import general from "@/plugins/i18n/de/general"
import auth from "@/plugins/i18n/de/auth"
import nav from "@/plugins/i18n/de/nav"
import audit from "@/plugins/i18n/de/audit"
import dashboard from "@/plugins/i18n/de/dashboard"
import employee from "@/plugins/i18n/de/employee"
import validation from "@/plugins/i18n/de/validation"
import category from "@/plugins/i18n/de/category"
import additionaleffort from "@/plugins/i18n/de/additionaleffort"
import material from "@/plugins/i18n/de/material"
import machine from "@/plugins/i18n/de/machine"
import customer from "@/plugins/i18n/de/customer"
import project from "@/plugins/i18n/de/project"
import settings from "@/plugins/i18n/de/settings"
import packet from "@/plugins/i18n/de/packet"
import userposition from "@/plugins/i18n/de/userposition"
import hourlywagereport from "@/plugins/i18n/de/hourlywagereport"
import hourlywageinvoice from "@/plugins/i18n/de/hourlywageinvoice"
import constructionreport from "@/plugins/i18n/de/constructionreport"
import violation from "@/plugins/i18n/de/violation"
import personnelplanning from "@/plugins/i18n/de/personnelplanning"
import timetracking from "@/plugins/i18n/de/timetracking"
import daysubmission from "@/plugins/i18n/de/daysubmission"
import toolbar from "@/plugins/i18n/de/toolbar"
import notification from "@/plugins/i18n/de/notification"
import file from "@/plugins/i18n/de/file"
import billing from "@/plugins/i18n/de/billing"
import onboarding from "@/plugins/i18n/de/onboarding"
import search from "@/plugins/i18n/de/search"
import dataexport from "@/plugins/i18n/de/dataexport"
import help from "@/plugins/i18n/de/help"
import releasenotes from "@/plugins/i18n/de/releasenotes"

export default {
  general,
  auth,
  nav,
  audit,
  dashboard,
  employee,
  validation,
  category,
  additionaleffort,
  material,
  machine,
  customer,
  project,
  settings,
  packet,
  userposition,
  hourlywagereport,
  hourlywageinvoice,
  constructionreport,
  violation,
  personnelplanning,
  timetracking,
  daysubmission,
  toolbar,
  billing,
  onboarding,
  notification,
  file,
  search,
  dataexport,
  help,
  releasenotes,
}
